import StickyNavigation from './StickyNavigation';

function Header(header) {
    // elements
    const _modifierClasses = ['header--small', 'header--medium', 'header--large'];
    const primaryNav = header.querySelector('.primary-nav');
    const primaryNavnavInner = primaryNav.querySelector('.primary-nav__inner');
    const primaryNavContainer = header.querySelector('.header__primary-nav');
    const menuButton = header.querySelector('.menu-button');
    const body = document.body;
    const openSearchButton = header.querySelector('.open-search-button');
    const allSearchButtons = header.querySelectorAll('.open-search-button');
    const searchOverlay = header.querySelector('.header__overlay');
    const headerSearchContainer = header.querySelector('.header__search');
    const closeSearchButton = header.querySelector('.header__search-close');

    // css classes
    const navigationOpenModifier = 'header__primary-nav--open';
    const mobileButtonOpenModifier = 'menu-button--open';
    const searchOpenModifier = 'header--search-open';
    const overFlowHidden = 'h-overflow-hidden';

    const escKeyCode = 27;
    let isSearchOpen = false;

    // Helper function to update aria-expanded for all search buttons
    function updateSearchButtonsState(expanded) {
        allSearchButtons.forEach(button => {
            button.setAttribute('aria-expanded', expanded);
        });
    }

    // listeners
    allSearchButtons.forEach(button => {
        button && button.addEventListener('click', toggleSearch);
    });
    searchOverlay && searchOverlay.addEventListener('click', toggleSearch);
    closeSearchButton && closeSearchButton.addEventListener('click', closeSearch);
    document.addEventListener('keydown', (e) => e.keyCode === escKeyCode && closeSearch());

    function clearAndAddBaseClasses() {
        let classListWithoutModifiers = [...header.classList].filter(
            (className) => !_modifierClasses.includes(className)
        );
        header.className = '';
        header.classList.add(...classListWithoutModifiers);
    }

    // function for applying a modifier class which works with the current view port width
    function addModifier(modifierClasses) {
        if (primaryNav.clientWidth < primaryNavnavInner.scrollWidth) {
            const currentModifier = modifierClasses[modifierClasses.length - 1];
            clearAndAddBaseClasses();
            header.classList.add(currentModifier);
            if (modifierClasses.length === 1) {
                return;
            }
            addModifier(_modifierClasses.slice(0, modifierClasses.length - 1));
        }
    }

    function toggleMobileMenu() {
        const blogPageHeaderWrapper =
            document.querySelector('.header-container-wrapper') || document.createElement('div');
        const topBarHeight =
            (document.querySelector('.top-bar') && document.querySelector('.top-bar').offsetHeight) || 0;
        const headerMainNavWrapper = primaryNavContainer.parentNode;
        const newMainNavWrapperHeight = window.innerHeight - topBarHeight;

        if (
            primaryNavContainer.classList.contains(navigationOpenModifier) &&
            menuButton.classList.contains(mobileButtonOpenModifier)
        ) {
            primaryNavContainer.classList.remove(navigationOpenModifier);
            menuButton.classList.remove(mobileButtonOpenModifier);
            blogPageHeaderWrapper.style.height = 'auto';
            headerMainNavWrapper.style.height = 'auto';
            body.classList.remove(overFlowHidden);
            header.classList.remove('header--mobile-menu-open');
        } else {
            primaryNavContainer.classList.add(navigationOpenModifier);
            menuButton.classList.add(mobileButtonOpenModifier);
            blogPageHeaderWrapper.style.height = '100%';
            headerMainNavWrapper.style.height = `${newMainNavWrapperHeight}px`;
            body.classList.add(overFlowHidden);
            header.classList.add('header--mobile-menu-open');
            animateHeader();
        }
        window.scrollTo(0, 0);

        if (!primaryNavContainer.classList.contains(navigationOpenModifier) && isSearchOpen) {
            toggleSearch();
        }
    }

    function recalculateMobileMenu() {
        // Check if mobile menu is open, then calculate.
        if (
            primaryNavContainer.classList.contains(navigationOpenModifier) &&
            menuButton.classList.contains(mobileButtonOpenModifier)
        ) {
            const topBarHeight =
                (document.querySelector('.top-bar') && document.querySelector('.top-bar').offsetHeight) || 0;
            const headerMainNavWrapper = primaryNavContainer.parentNode;
            const newMainNavWrapperHeight = window.innerHeight - topBarHeight;

            headerMainNavWrapper.style.height = `${newMainNavWrapperHeight}px`;
            primaryNavContainer.scrollTop = 0;
        }
    }

    function animateHeader() {
        header.classList.add('header--mobile-menu-animate');

        setTimeout(() => {
            header.classList.remove('header--mobile-menu-animate');
            primaryNavContainer.scrollTop = 0;
        }, 310);
    }

    function closeSearch() {
        const searchFieldContainer = header.querySelector('.search-field');
        const searchField = header.querySelector('.search-field input');
        isSearchOpen = false;
        updateSearchButtonsState(isSearchOpen);

        header.classList.remove(searchOpenModifier);

        if (searchField) {
            !isSearchOpen && searchField.blur();
            searchFieldContainer.classList.remove('is-open');
            toggleOverflow();
        }
    }

    function toggleSearch() {
        const searchFieldContainer = header.querySelector('.search-field');
        const searchField = header.querySelector('.search-field input');
        isSearchOpen = !JSON.parse(
            openSearchButton.getAttribute('aria-expanded')
        );
        openSearchButton.setAttribute(
            'aria-expanded',
            JSON.stringify(isSearchOpen)
        );
        updateSearchButtonsState(isSearchOpen);

        header.classList.toggle(searchOpenModifier, isSearchOpen);

        if (searchField) {
            isSearchOpen
                ? searchFieldContainer.classList.add('is-open')
                : searchFieldContainer.classList.remove('is-open');
            isSearchOpen ? searchField.focus() : searchField.blur();

            toggleOverflow();
        }
    }

    function toggleOverflow() {
        const method = isSearchOpen ? 'add' : 'remove';
        document.querySelector('html').classList[method](overFlowHidden);
        document.body.classList[method](overFlowHidden);
    }

    // initial check
    addModifier(_modifierClasses);
    StickyNavigation(header);

    // listiners
    window.addEventListener('resize', () => {
        addModifier(_modifierClasses);
        StickyNavigation(header);
    });
    menuButton.addEventListener('click', toggleMobileMenu);
    header.addEventListener('recalculate', () => {
        recalculateMobileMenu();
        StickyNavigation(header);
    });
    headerSearchContainer.addEventListener('close-header-search', closeSearch);
}

export default Header;
